document.querySelectorAll('.js-select').forEach(select => {
    const header = select.querySelector('.js-select__header');
    const items = select.querySelectorAll('.js-select__item');
    const current = select.querySelector('.js-select__current');
  
    header.addEventListener('click', () => {
      select.classList.toggle('active');
    });
  
    items.forEach(item => {
      item.addEventListener('click', () => {
        const value = item.dataset.value;
        const label = item.textContent;
  
        current.textContent = label;
        select.classList.remove('active');
        const event = new CustomEvent('select:change', {
          bubbles: true,
          detail: {
            value,
            label,
            select 
          }
        });
  
        select.dispatchEvent(event);
      });
    });
  });
  
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.js-select').forEach(select => {
      if (!select.contains(e.target)) {
        select.classList.remove('active');
      }
    });
  });